import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VideocountComponent } from './videocount/videocount.component';
import { title } from 'process';
import { UsersVideoCountComponent } from './users-video-count/users-video-count.component';

const routes: Routes = [
   {
      path: '',
      data: {
        title: 'Videos'
      },
      children: [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'videos'
        },
        // {
        //   path: 'videos',
        //   component: VideocountComponent,
        //   data: {
        //     title: 'Video Count'
        //   }
        // },  
        {
          path: 'users-video-count',
          component: UsersVideoCountComponent,
          data: {
            title: 'Users Video Count'
          }
        },   
      ]
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VideosRoutingModule { }
